import { BaseWorkflowRuleCollection } from '@/modules/workflow/models/BaseWorkflowRuleCollection';
import { WorkflowAssignee } from '@/modules/workflow/models/WorkflowAssignee';
import { User } from '@/modules/user/models/User';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class WorkflowAssigneeCollection extends BaseWorkflowRuleCollection<WorkflowAssignee> {
  constructor(items: WorkflowAssignee[] | WorkflowAssigneeCollection | undefined) {
    super(items, WorkflowAssignee);
  }

  static mapModel(
    items: WorkflowAssignee[] | WorkflowAssigneeCollection | undefined
  ): WorkflowAssigneeCollection {
    return new this(items);
  }

  get users(): Array<User | undefined> {
    return this.items?.map((assignee: WorkflowAssignee): User | undefined => assignee.user) ?? [];
  }

  sync(assignees: User[]): void {
    super.syncRules(
      assignees.map(
        (user: User): WorkflowAssignee =>
          WorkflowAssignee.mapModel({ modelType: ModelType.USER, modelId: user.id, user })
      )
    );
  }
}
